'use client'

import { useTranslate } from '@marketplace-web/shared/i18n'

const IntroductionSection = () => {
  const translate = useTranslate('dac7-2024.introduction')

  return (
    <section className="dac7__introduction" data-testid="introduction-section">
      <h1 className="dac7__introduction-title">{translate('title')}</h1>
      <p className="dac7__introduction-description">{translate('description')}</p>
    </section>
  )
}

export default IntroductionSection
